import { SVG } from '../SVG'

export const MyAccount = ({ inactive = false, style = {}, ...props }) => {
  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
      <path
        d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 15C14.0711 15 15.75 13.3211 15.75 11.25C15.75 9.17893 14.0711 7.5 12 7.5C9.92893 7.5 8.25 9.17893 8.25 11.25C8.25 13.3211 9.92893 15 12 15Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.98047 18.6938C6.54476 17.5824 7.40581 16.6488 8.46816 15.9968C9.53052 15.3447 10.7527 14.9995 11.9992 14.9995C13.2457 14.9995 14.4679 15.3447 15.5303 15.9968C16.5926 16.6488 17.4537 17.5824 18.018 18.6938'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SVG>
  )
}
